<template>
  <div class="self-center flex w-full flex-col items-center">
    <img src="/static/empty.svg" class="h-[40vw] lg:h-[16rem]" />
    <div class="font-[300] text-gray-500">Não há resultados</div>
  </div>
</template>
